var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_1070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7143 10.7143V4.125C10.7143 3.50368 11.218 3 11.8393 3H12.1607C12.782 3 13.2857 3.50368 13.2857 4.125V10.7143H19.875C20.4963 10.7143 21 11.218 21 11.8393V12.1607C21 12.782 20.4963 13.2857 19.875 13.2857H13.2857V19.875C13.2857 20.4963 12.782 21 12.1607 21H11.8393C11.218 21 10.7143 20.4963 10.7143 19.875V13.2857H4.125C3.50368 13.2857 3 12.782 3 12.1607V11.8393C3 11.218 3.50368 10.7143 4.125 10.7143H10.7143Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLine);
export default __webpack_public_path__ + "static/media/add-line.26737618db0dcbb44bfed7d07a6eb257.svg";
export { ForwardRef as ReactComponent };